// GENERATO AUTOMATICAMENTE da scripts/generateApiDocs.js
// Non modificare manualmente - aggiornato ad ogni commit
export const API_DOCS = [
  {
    method: 'GET',
    endpoint: '/api/sal/:id',
    requestBody: null,
    response: '{"success":true,"data":{"id":"number","societaId":"number","sedeId":"number","commessaId":"number","ordineId":"number|null","numero":"string|null","stato":"BOZZA|EMESSO|APPROVATO_CLIENTE|APPROVATO_BACKOFFICE|FATTURATO","dataEmissione":"string","dataApprovazione":"string","tipoApprovazione":"CLIENTE|BACKOFFICE","riferimentoApprovazione":"string","noteApprovazione":"string","importoTotale":"number","tipoDocumento":{"id":"number","codice":"string","nome":"string"},"fatturaCollegata":{"id":"number","numero":"string|null","stato":"string"},"createdAt":"string","ordine":{"id":"number","numero":"string","flussoCommerciale":"string"},"commessa":{"id":"number","numero":"string","descrizione":"string","clienteRagioneSociale":"string"},"createdBy":{"id":"number","nome":"string","cognome":"string"},"righe":[{"id":"number","ordinePos":"number","rigaOrdineId":"number|null","rigaDistintaExtraId":"number|null","descrizione":"string","quantitaTotale":"number|null","quantitaPrecedente":"number","quantitaCorrente":"number","prezzoUnitario":"number","importoCorrente":"number","rigaOrdine":{"ordinePos":"number","descrizione":"string","quantita":"number","ordine":{"id":"number","numero":"string"}},"rigaDistintaExtra":{"id":"number","distintaId":"number","descrizione":"string"}}],"storniAcconto":[{"id":"number","proformaAccontoId":"number","importoStornato":"number","proforma":{"id":"number","numero":"string","totale":"number","dataPagamento":"string|null"}}],"logs":[{"id":"number","utenteName":"string","azione":"string","dettaglio":"string","createdAt":"string"}]}}'
  },
  {
    method: 'POST',
    endpoint: '/api/sal/:id/emetti',
    requestBody: null,
    response: '{"success":true,"data":{"stato":"EMESSO","numero":"string","dataEmissione":"string"}}'
  },
  {
    method: 'DELETE',
    endpoint: '/api/sal/:id',
    requestBody: null,
    response: '{"success":true}'
  },
  {
    method: 'POST',
    endpoint: '/api/sal/:id/approva',
    requestBody: '{"tipoApprovazione":"CLIENTE|BACKOFFICE","noteApprovazione":"string|null","riferimentoApprovazione":"string|null"}',
    response: '{"success":true,"data":{"stato":"APPROVATO_CLIENTE|APPROVATO_BACKOFFICE"}}'
  },
  {
    method: 'POST',
    endpoint: '/api/fatture/da-sal',
    requestBody: '{"salId":"number"}',
    response: '{"success":true,"data":{"id":"number"}}'
  },
  {
    method: 'GET',
    endpoint: '/api/sal/sorgente?commessaId',
    requestBody: null,
    response: '{"success":true,"data":{"ordini":[{"id":"number","numero":"string","righe":[{"rigaOrdineId":"number","ordinePos":"number","descrizione":"string","quantitaTotale":"number|null","quantitaPrecedente":"number","residua":"number|null","prezzoUnitario":"number"}]}]}}'
  },
  {
    method: 'PUT',
    endpoint: '/api/sal/:id',
    requestBody: '{"righe":[{"rigaOrdineId":"number?","rigaDistintaExtraId":"number?","descrizione":"string","quantitaTotale":"number|null","quantitaPrecedente":"number","quantitaCorrente":"number","prezzoUnitario":"number","importoCorrente":"number"}],"storni":[{"proformaAccontoId":"number","importoStornato":"number"}]}',
    response: '{"success":true}'
  }
] as const;

export type ApiDoc = typeof API_DOCS[number];
